import { render, staticRenderFns } from "./viewitemDetailsSingle.vue?vue&type=template&id=1744121e&scoped=true"
import script from "./viewitemDetailsSingle.vue?vue&type=script&lang=js"
export * from "./viewitemDetailsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1744121e",
  null
  
)

export default component.exports